<template>
  <div class="px-2 py-1 text-gray-700 bg-gray-100 flex flex-col space-y-1">
    <div class="flex items-center space-x-2">
      <img :src="client.logo" :alt="client.name" class="w-6 h-6 rounded-full border" />
      <span class="inline-block leading-5 text-xs truncate">
        {{ client.name }}
      </span>
    </div>
    <span class="inline-block truncate leading-5 text-xs">{{ project.name }}</span>
  </div>
</template>

<script>
export default {
  name: 'KanbanBoardTaskListLineProject',
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  computed: {
    client() {
      if (!this.project.client) {
        return null;
      }

      return this.$store.state.entities.accounts.byId[this.project.client];
    },
  },
};
</script>
